import { Address } from './Address'

export class CompanyServiceProvider {
		constructor() {
				this.socialName = null
				this.stateRegistration = null
				this.comments = null
				this.email = null
				this.ramal = null,
				this.telephone = null,
				this.cellphone = null,
				this.cnpj = null,
				this.handlerOperations = []
		}
		public id: number
		public idMongo: string
		public socialName: string
		public cnpj: string
		public stateRegistration: string
		public cellphone: string
		public telephone: string
		public ramal: string
		public site: string
		public email: string
		public comments: string
		public companyId: string
		public status: string
		public editDate: string
		public createdDate: string
		public Address: Address = new Address()
		public handlerOperations: Array<number>
}

export class CompanyServiceProviderListParams {
		public companyId: string = ''
		public skip: number = 0
		public limit: number = 10
		public order: string = 'CNPJ'
		public typeOrder: string = 'desc'
		public handlerOperationIds?: Array<string> = []
}
